import styled from "styled-components"
import Color from "../../../style/enum/color"

export const Headline = styled.div`
  color: ${Color.DIMGRAY};
  font-size: 0.9rem;
  margin-bottom: 2px;
`
